import React from 'react';
import { Card, Button } from '@/components/ui';

interface ChecklistItem {
  id: string;
  label: string;
  description: string;
  isCompleted: boolean;
  action?: {
    label: string;
    onClick: () => void;
  };
}

interface OnboardingChecklistProps {
  items: ChecklistItem[];
}

export function OnboardingChecklist({ items }: OnboardingChecklistProps) {
  const completedCount = items.filter(i => i.isCompleted).length;
  const progress = (completedCount / items.length) * 100;

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="font-bold text-slate-900">Hoàn tất Thiết lập Tổ chức</h3>
          <p className="text-xs text-slate-500 mt-1">Hoàn thành các bước dưới đây để tối ưu hóa việc quản lý dự án.</p>
        </div>
        <div className="text-right">
          <p className="text-lg font-black text-os-primary">{Math.round(progress)}%</p>
          <p className="text-[10px] text-slate-400 font-bold  tracking-wider">Hoàn thành</p>
        </div>
      </div>

      <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden mb-8">
        <div className="h-full bg-os-primary transition-all duration-1000" style={{ width: `${progress}%` }} />
      </div>

      <div className="space-y-4">
        {items.map((item) => (
          <div
            key={item.id}
            className={`
              p-4 rounded-2xl border transition-all flex items-start gap-4
              ${item.isCompleted ? 'bg-slate-50 border-slate-100 opacity-60' : 'bg-white border-slate-100 hover:border-os-primary/20'}
            `}
          >
            <div className={`
              w-6 h-6 rounded-full flex items-center justify-center shrink-0 mt-0.5
              ${item.isCompleted ? 'bg-emerald-500 text-white' : 'border-2 border-slate-200 text-slate-300'}
            `}>
              {item.isCompleted ? <i className="ri-check-line" /> : <i className="ri-checkbox-blank-circle-line" />}
            </div>

            <div className="flex-1">
              <h4 className={`text-sm font-bold ${item.isCompleted ? 'text-slate-500 line-through' : 'text-slate-900'}`}>
                {item.label}
              </h4>
              <p className="text-xs text-slate-500 mt-1">{item.description}</p>
            </div>

            {!item.isCompleted && item.action && (
              <Button variant="ghost" size="sm" onClick={item.action.onClick} className="text-os-primary hover:bg-os-primary/5">
                {item.action.label}
              </Button>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
